import { render, staticRenderFns } from "./Vozvrat_po_chekam.vue?vue&type=template&id=cac54c90&scoped=true&"
import script from "./Vozvrat_po_chekam.vue?vue&type=script&lang=js&"
export * from "./Vozvrat_po_chekam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac54c90",
  null
  
)

export default component.exports